var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Form from "@irati/ui/src/Form";
import authentication from "@irati/auth";
import File from "@irati/ui/src/FormItem/File";
import Input from "@irati/ui/src/FormItem/Input";
import Select from "@irati/ui/src/FormItem/Select";
import { Checkbox } from "@irati/ui/src/FormItem";
import Validation from "@irati/utils/validation";
import { Para } from "@irati/ui/src/Labels";
import Link from "@irati/ui/src/Link";
import Button from "@irati/ui/src/Button";
import { H3, H4, H5, Body } from "@irati/ui/src/Typography";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Hr from "@irati/ui/src/Layout/Hr";
import { createSamlIdentityProvider, getProviderByTenantReference } from "@irati/sso/services/sso";
import { initiateSamlLogin } from "@irati/sso/helpers/webSSOPopup";
import businessService from "@irati/identity/services/business";
import Loading from "@irati/ui/src/Loading";
import { SAML_REQUEST_TYPES, SAML_REQUEST_TYPE_POST, RESOLVED_SAML_REQUEST_TYPES_KEY } from "@irati/sso/constants/signUpOptions";
import adminTracking from "@irati-tracking/admin";
import { store } from "@irati/store";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import { hangPromise } from "@irati/utils/promise";
import SAMLKeyValue from "./SAMLKeyValue";
var SAMLSingleSignOn = /** @class */ (function (_super) {
    __extends(SAMLSingleSignOn, _super);
    function SAMLSingleSignOn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            SAMLRequestType: null,
            requiresAuthNRequest: false,
            SAMLRequestName: null,
            SAMLRequestIssuer: null,
            hideNormalLogin: false,
            load: hangPromise(),
            providerMetadata: null,
            saving: null,
            saved: false,
            showSamlInformation: false,
            uuid: null,
            ssoButtonText: _this.props.ssoButtonText,
            isTestingSSO: null
        };
        _this.getSAMLRequestTypes = function () {
            var formatMessage = _this.props.formatMessage;
            return RESOLVED_SAML_REQUEST_TYPES_KEY.map(function (type) { return ({ value: type.value, label: formatMessage({ id: type.label }) }); });
        };
        _this.onChange = function (label, value) {
            var _a;
            if (label === "requiresAuthNRequest" && _this.state.SAMLRequestType !== SAML_REQUEST_TYPE_POST) {
                _this.setState(function (state) { return ({
                    requiresAuthNRequest: !state.requiresAuthNRequest
                }); });
            }
            else {
                _this.setState((_a = {}, _a[label] = value, _a));
            }
        };
        _this.updateTenantSettings = function () {
            var _a = _this.props, userTenant = _a.userTenant, handleSave = _a.handleSave, formatMessage = _a.formatMessage;
            var _b = _this.state, ssoButtonText = _b.ssoButtonText, hideNormalLogin = _b.hideNormalLogin;
            var data = {
                uuid: userTenant.uuid,
                loginPageSsoButtonText: ssoButtonText,
                showPasswordLogin: !hideNormalLogin,
                showSsoLogin: true
            };
            var isTestingSSO = businessService.update({ data: data }).then(function () {
                return store.dispatch(AuthActions.updateTenant()).then(function () {
                    _this.setState({ isTestingSSO: null });
                    handleSave(formatMessage({ id: "admin.components.samlSingleSignOn.updateTenantSettings.setUp" }));
                    adminTracking.enableSSO();
                });
            });
            _this.setState({
                isTestingSSO: isTestingSSO
            });
        };
        _this.saveSaml = function () {
            var _a = _this.state, providerMetadata = _a.providerMetadata, SAMLRequestType = _a.SAMLRequestType, SAMLRequestName = _a.SAMLRequestName, SAMLRequestIssuer = _a.SAMLRequestIssuer, requiresAuthNRequest = _a.requiresAuthNRequest;
            var formData = new FormData();
            formData.append("metadata-file", new Blob([providerMetadata], { type: "application/xml" }));
            formData.append("tenant", _this.props.userTenant.uuid);
            formData.append("saml_request_type", SAMLRequestType);
            if (requiresAuthNRequest || SAMLRequestType === SAML_REQUEST_TYPE_POST) {
                formData.append("saml_request_name", SAMLRequestName);
                formData.append("saml_request_issuer", SAMLRequestIssuer);
            }
            var saving = createSamlIdentityProvider(formData).then(function (response) {
                _this.setState({
                    uuid: response.data.uuid,
                    saved: true,
                    saving: null,
                    showSamlInformation: true
                });
            });
            _this.setState({ saving: saving });
        };
        _this.testSSO = function () {
            initiateSamlLogin(authentication.userTenant()).then(_this.updateTenantSettings);
        };
        _this.editSaml = function () {
            _this.setState({
                showSamlInformation: false
            });
        };
        return _this;
    }
    SAMLSingleSignOn.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            load: getProviderByTenantReference()
                .then(function (res) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                var SAMLRequestIssuer = (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.saml) === null || _c === void 0 ? void 0 : _c.SAMLRequestIssuer;
                var SAMLRequestName = (_f = (_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.saml) === null || _f === void 0 ? void 0 : _f.SAMLRequestName;
                _this.setState({
                    SAMLRequestType: (_j = (_h = (_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.saml) === null || _j === void 0 ? void 0 : _j.SAMLRequestType,
                    requiresAuthNRequest: !!(SAMLRequestName || SAMLRequestIssuer),
                    SAMLRequestName: SAMLRequestName,
                    SAMLRequestIssuer: SAMLRequestIssuer
                });
            })
                .catch(function (err) {
                if (err.response.status !== 404) {
                    throw new Error(err);
                }
            })
        });
    };
    SAMLSingleSignOn.prototype.render = function () {
        var _this = this;
        var _a = this.props, hideDocHint = _a.hideDocHint, formatMessage = _a.formatMessage, userTenant = _a.userTenant;
        var _b = this.state, showSamlInformation = _b.showSamlInformation, load = _b.load, ssoButtonText = _b.ssoButtonText, providerMetadata = _b.providerMetadata, SAMLRequestIssuer = _b.SAMLRequestIssuer, SAMLRequestName = _b.SAMLRequestName, SAMLRequestType = _b.SAMLRequestType, hideNormalLogin = _b.hideNormalLogin, requiresAuthNRequest = _b.requiresAuthNRequest, saving = _b.saving, saved = _b.saved, uuid = _b.uuid, isTestingSSO = _b.isTestingSSO;
        var ssoDocsLink = (React.createElement(Link, { href: formatMessage({ id: "admin.components.samlSingleSignOn.link.href" }), rel: "noopener noreferrer", target: "_blank" },
            React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.link.text" })));
        return (React.createElement(Loading, { load: load },
            !hideDocHint && (React.createElement(Body, null,
                React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.viewDocumentation.textV2", values: { link: ssoDocsLink } }))),
            !userTenant.settings.showSSOOptions && (React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.headerThree.contact" }))),
            React.createElement(H3, { marginTop: 2, marginBottom: 2 },
                React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.header.stepOne" })),
            showSamlInformation ? (React.createElement(Button, { className: "pull-right", onClick: this.editSaml },
                React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.button.edit" }))) : (React.createElement(Form, null,
                React.createElement(Input, { name: "ssoButtonText", label: formatMessage({ id: "admin.components.samlSingleSignOn.input.label.loginButton.text" }), placeholder: formatMessage({ id: "admin.components.samlSingleSignOn.input.placeholder.singleSignOn.text" }), value: ssoButtonText, hint: formatMessage({ id: "admin.components.samlSingleSignOn.input.hint.singleSignOn.text" }), type: "text", onChange: function (value) { return _this.onChange("ssoButtonText", value); }, validation: Validation.string(formatMessage({ id: "admin.components.samlSingleSignOn.input.validation.required" })).max(50, formatMessage({ id: "admin.components.samlSingleSignOn.input.validation.maxCharacters" })) }),
                React.createElement(File, { label: formatMessage({ id: "admin.components.samlSingleSignOn.file.label" }), type: ".xml", name: "providerMetadata", file: providerMetadata, onChange: function (file) {
                        _this.onChange("providerMetadata", file[0]);
                    }, validation: Validation.string(formatMessage({ id: "admin.components.samlSingleSignOn.file.validation.required" })) }),
                React.createElement(Select, { name: "SAMLRequestType", label: formatMessage({ id: "admin.components.samlSingleSignOn.select.label" }), value: SAMLRequestType, isClearable: false, options: this.getSAMLRequestTypes(), onChange: function (value) { return _this.onChange("SAMLRequestType", value); }, validation: Validation.string(formatMessage({ id: "admin.components.samlSingleSignOn.select.validation.required" })).oneOf(SAML_REQUEST_TYPES, formatMessage({ id: "admin.components.samlSingleSignOn.select.validation.oneOf" })) }),
                React.createElement(Checkbox, { name: "hideNormalLogin", checked: hideNormalLogin, onChange: function () { return _this.onChange("hideNormalLogin", !hideNormalLogin); } },
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.hideNormalLogin.text" })),
                React.createElement(Checkbox, { name: "requiresAuthNRequest", checked: requiresAuthNRequest || SAMLRequestType === SAML_REQUEST_TYPE_POST, onChange: function () { return _this.onChange("requiresAuthNRequest"); } },
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.requiresAuthNRequest.text" })),
                (requiresAuthNRequest || SAMLRequestType === SAML_REQUEST_TYPE_POST) && (React.createElement(React.Fragment, null,
                    React.createElement(Input, { name: "SAMLRequestName", label: formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestName.input.label" }), placeholder: formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestName.input.placeholder" }), value: SAMLRequestName, type: "text", onChange: function (value) { return _this.onChange("SAMLRequestName", value); }, validation: Validation.string(formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestName.input.validation.required" }))
                            .max(50)
                            .matches(/^[a-z0-9_-]*$/i, formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestName.input.validation.matches" })) }),
                    React.createElement(Input, { name: "SAMLRequestIssuer", label: formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestIssuer.input.label" }), placeholder: formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestIssuer.input.placeholder" }), value: SAMLRequestIssuer, onChange: function (value) { return _this.onChange("SAMLRequestIssuer", value); }, validation: Validation.string(formatMessage({ id: "admin.components.samlSingleSignOn.samlRequestIssuer.input.validation.required" })) }))),
                React.createElement(ValidationButton, { loading: saving, primary: true, onClick: this.saveSaml, style: { marginTop: 15 } },
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.validationButton.continue" })))),
            saved && (React.createElement(React.Fragment, null,
                React.createElement(Hr, null),
                React.createElement(H3, { style: { marginBottom: 15 } },
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.header.stepTwo" })),
                React.createElement(H4, null,
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.headerFour.information" })),
                React.createElement(H4, { small: true },
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.headerFour.dynamicAssertions" })),
                React.createElement(H5, null,
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.headerFive.userUniqueId" })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.saml.format.text" })),
                React.createElement(SAMLKeyValue, { value: uuid, namekey: "https://sso.perkbox.co.uk/SAML/Attributes/Tenant/UUID" }),
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.headerFour.staticAssertions" }),
                    "\u00A0",
                    ssoDocsLink),
                React.createElement(Button, { loading: isTestingSSO, primary: true, onClick: this.testSSO, style: { marginTop: 15 } },
                    React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.button.testAndSave" }))))));
    };
    return SAMLSingleSignOn;
}(Component));
export default injectIntl(SAMLSingleSignOn);
